import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuthStore } from "../lib/auth-store";
import { landingPath } from "../lib/session";

/**
 * Route-level gate for the platform panel — mirrors RequirePortal, but checks
 * `isPlatformStaff` rather than a Role-derived portal, since tenant
 * management is orthogonal to Membership/Role entirely. Server-side,
 * PlatformStaffGuard is the boundary that actually matters; this only
 * decides what an ordinary school user is shown instead of a wall of 403s.
 */
export function RequirePlatformStaff({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);

  if (!user) return <Navigate to="/login" replace />;
  if (!user.isPlatformStaff) return <Navigate to={landingPath(user)} replace />;

  return <>{children}</>;
}
